import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { actionActionSearchTrip } from "actions/action/actions";
import filterTypes from "data/filter-types";
import BikeTrip from "views/lib/components/maps/bike-trip";

const BikePath = (props) => {
    const [count, setCount] = useState(50);
    const {
        bikeId,
        actionActionSearchTrip,
        singleTrip
    } = props;

    const handleLoad = () => {
        actionActionSearchTrip(0, count, undefined, [{
            fieldName: "bike",
            fieldValue: bikeId,
            searchOperation: filterTypes.EQUALS.value
        }]);
    };

    useEffect(() => {
        handleLoad();
    }, []);

    return (
        <div style={{
            height: 500
        }}>
            <div className="bike-path-trips-header">
                <div className="clearfix bike-trip-colors">
                    <div>Start</div>
                    <div>End</div>
                </div>

                <div className="form-inline">
                    <div className="input-group mb-2">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Result Count</span>
                        </div>
                        <input
                            className="form-control form-control-sm"
                            type="number"
                            value={count}
                            min={1}
                            onChange={ev => setCount(parseInt(ev.target.value, 10))}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-sm btn-success" type="btn" onClick={handleLoad}>Get</button>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{
                height: "calc(100% - 30px)"
            }}>
                {singleTrip && singleTrip.content && singleTrip.content.length ?
                    <BikeTrip
                        pathCoordinates={singleTrip.content.map(item => ({
                            lng: item.position.coordinates[0],
                            lat: item.position.coordinates[1],
                            marker: moment(item.date)
                                .format("HH:mm DD-MM-YYYY")
                        }))}
                    />
                    : null}
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    singleTrip: state.action.singleTrip,
});


const mapStateToDispatch = dispatch => ({
    actionActionSearchTrip: bindActionCreators(actionActionSearchTrip, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(BikePath);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/bike-path.js